module.exports = __webpack_public_path__ + "static/media/PM89.d4db3607.JPG";